/**
 * This file is to keep all session and local storage keys in one place.
 */

export const STORAGE_KEYS = {
  MIGRATION_VERSION_RESET_VALUE: 'default',
  MIGRATION_VERSION_SEARCH_PARAM: 'v',
  MIGRATION_VERSION_STORAGE_KEY: 'msr:migration-version',
  SELECTED_WORKSPACE: 'selectedWorkspace',
};
